
<div>
	<v-container align="center" justify="center" class="pa-5 pb-0">
		<v-list-item three-line>
			<v-list-item-content>
				<v-list-item-title class="mb-1 text-center text-wrap">
					<h1>{{ getLabel('educationSectionHeader', 'Education') }}</h1>
				</v-list-item-title>
				<v-list-item-subtitle class="text-center text-wrap">
					{{ getLabel('educationSectionDescription', 'For increased credibility, tell us about your qualifications.') }}
				</v-list-item-subtitle>
			</v-list-item-content>
		</v-list-item>
	</v-container>

	<v-card-text align="center" justify="center" class="justify-center text-center pb-0 pm-0">
		<qualifications-form :solo="false"></qualifications-form>
	</v-card-text>
</div>
